const blacklist = [
  'ass',
  'azz',
  'bbw',
  'cok',
  'cox',
  'cum',
  'dix',
  'ero',
  'evl',
  'fag',
  'fck',
  'feg',
  'fok',
  'fuk',
  'fux',
  'fvk',
  'gae',
  'gai',
  'gey',
  'gfy',
  'gob',
  'goy',
  'gub',
  'gyp',
  'hoe',
  'hui',
  'ike',
  'jap',
  'jig',
  'jiz',
  'kkk',
  'kuk',
  'kum',
  'kwa',
  'lds',
  'lez',
  'lsd',
  'nad',
  'nig',
  'neg',
  'nip',
  'nob',
  'nog',
  'pcp',
  'pis',
  'pms',
  'pud',
  'sac',
  'sex',
  'sob',
  'tit',
  'uzi',
  'vag',
  'wab',
  'wad',
  'wog',
  'wop',
  'wtf',
  'xtc',
  'xxx',
  'yed',
  'yid',
  'kil',
  'rap',
  'oob',
  'cow',
  'dry',
  'les',
  'red',
  'abbo',
  'anal',
  'anus',
  'armo',
  'arse',
  'ayir',
  'barf',
  'bdsm',
  'bint',
  'bomd',
  'bong',
  'btch',
  'bule',
  'bung',
  'caca',
  'cawk',
  'chav',
  'chug',
  'chuj',
  'cipa',
  'clit',
  'cnts',
  'cntz',
  'cnut',
  'cock',
  'coon',
  'cunn',
  'cunt',
  'dago',
  'damm',
  'damn',
  'dego',
  'deth',
  'dick',
  'dilf',
  'dink',
  'dlck',
  'dong',
  'drug',
  'dupa',
  'dvda',
  'dyke',
  'ekto',
  'fack',
  'faen',
  'faig',
  'fcuk',
  'feck',
  'fitt',
  'floo',
  'foad',
  'fook',
  'fuck',
  'fvck',
  'fxck',
  'gays',
  'gayz',
  'geni',
  'ghay',
  'ghey',
  'gipp',
  'gook',
  'gora',
  'groe',
  'gtfo',
  'guro',
  'haji',
  'hapa',
  'hebe',
  'heeb',
  'hell',
  'herp',
  'homo',
  'hoor',
  'hore',
  'hori',
  'hork',
  'ikwe',
  'jerk',
  'jism',
  'jiss',
  'jugg',
  'jugs',
  'kawk',
  'kink',
  'klan',
  'kock',
  'koon',
  'kunt',
  'kusi',
  'kyke',
  'lebo',
  'lech',
  'limy',
  'loin',
  'lust',
  'mams',
  'merd',
  'meth',
  'mick',
  'milf',
  'mofo',
  'moky',
  'muff',
  'muie',
  'mung',
  'munt',
  'nazi',
  'nsfw',
  'nude',
  'oral',
  'orga',
  'orgy',
  'ovum',
  'paki',
  'paky',
  'payo',
  'peck',
  'pedo',
  'perv',
  'phuc',
  'phuk',
  'phuq',
  'piky',
  'pimp',
  'pohm',
  'poof',
  'poon',
  'porn',
  'pric',
  'prig',
  'pron',
  'pthc',
  'pube',
  'puke',
  'pula',
  'pule',
  'puss',
  'pusy',
  'puta',
  'puto',
  'quim',
  'rere',
  'rump',
  'scag',
  'scat',
  'shag',
  'shat',
  'shav',
  'shit',
  'shiz',
  'shyt',
  'skag',
  'skwe',
  'slag',
  'slut',
  'smeg',
  'smut',
  'spac',
  'spic',
  'spig',
  'spik',
  'sqeh',
  'squa',
  'stfu',
  'suck',
  'suka',
  'taff',
  'tard',
  'teat',
  'teez',
  'terd',
  'thug',
  'toke',
  'turd',
  'tush',
  'twat',
  'vgra',
  'vibe',
  'vibr',
  'wang',
  'wank',
  'weed',
  'wetb',
  'whit',
  'whiz',
  'whop',
  'wuss',
  'xkwe',
  'yank',
  'yaoi',
  'meat',
  'ball',
  'bang',
  'fist',
  'jack',
  'head',
  'face',
  'gasm',
  'abeed',
  'abuse',
  'ahole',
  'amcik',
  'argie',
  'arian',
  'arrse',
  'aryan',
  'babes',
  'bawdy',
  'bimbo',
  'bitch',
  'boang',
  'boche',
  'bogan',
  'boink',
  'boned',
  'boner',
  'boody',
  'boong',
  'booty',
  'boozy',
  'bosch',
  'chinc',
  'chink',
  'choad',
  'chode',
  'chraa',
  'chute',
  'cohee',
  'cooly',
  'crabs',
  'crash',
  'cushi',
  'darky',
  'daygo',
  'deggo',
  'demon',
  'dildo',
  'dirsa',
  'doosh',
  'duche',
  'dummy',
  'eatme',
  'ecchi',
  'ekrem',
  'enema',
  'erect',
  'fanyy',
  'farty',
  'fatah',
  'fatso',
  'fecal',
  'feces',
  'felch',
  'forni',
  'fotze',
  'freex',
  'frigg',
  'fubar',
  'fucck',
  'fugly',
  'fuuck',
  'ganja',
  'ginzo',
  'glans',
  'godam',
  'gooch',
  'groid',
  'grope',
  'gross',
  'gspot',
  'guido',
  'guizi',
  'gyopo',
  'hadji',
  'hajji',
  'hamas',
  'haole',
  'harem',
  'heshe',
  'hobag',
  'homey',
  'honky',
  'hooch',
  'horny',
  'hoser',
  'husky',
  'hussy',
  'hymen',
  'hymie',
  'indon',
  'injun',
  'jebus',
  'jerry',
  'jewed',
  'jihad',
  'jisim',
  'junky',
  'kacap',
  'kafir',
  'kooch',
  'kraut',
  'kurac',
  'kurwa',
  'kushi',
  'kyopo',
  'kyrpa',
  'labia',
  'leper',
  'limey',
  'lmfao',
  'lubra',
  'lugan',
  'lynch',
  'mgger',
  'mggor',
  'mibun',
  'minge',
  'mocky',
  'moron',
  'mutha',
  'naked',
  'nastt',
  'nasty',
  'necro',
  'niigr',
  'ninny',
  'nooky',
  'nudie',
  'nymph',
  'osama',
  'packi',
  'packy',
  'paddy',
  'pansy',
  'panti',
  'panty',
  'paska',
  'pasty',
  'penas',
  'pendy',
  'penis',
  'penus',
  'perse',
  'picka',
  'pillu',
  'pinko',
  'pizda',
  'pocha',
  'pocho',
  'polac',
  'polak',
  'pommy',
  'pubic',
  'pubis',
  'punky',
  'punta',
  'puuke',
  'queaf',
  'queef',
  'quiff',
  'qweir',
  'randy',
  'reich',
  'ruski',
  'sadis',
  'sadom',
  'sambo',
  'sandm',
  'scank',
  'scrog',
  'scrot',
  'scrud',
  'semen',
  'seppo',
  'shhit',
  'shota',
  'sissy',
  'skank',
  'skeet',
  'slant',
  'slave',
  'slopy',
  'smack',
  'snuff',
  'sodom',
  'sooty',
  'souse',
  'spade',
  'spank',
  'sperm',
  'spunk',
  'stagg',
  'taboo',
  'teets',
  'teste',
  'toots',
  'tramp',
  'trois',
  'trots',
  'twink',
  'twunt',
  'ukrop',
  'unwed',
  'usama',
  'ussys',
  'vittu',
  'vixen',
  'vodka',
  'vomit',
  'vulva',
  'wazoo',
  'wench',
  'whash',
  'whoar',
  'wigga',
  'willy',
  'woody',
  'yiffy',
  'yobbo',
  'black',
  'dooch',
  'screw',
  'aeolus',
  'areola',
  'areole',
  'azazel',
  'bampot',
  'beaner',
  'beaney',
  'beatch',
  'beaver',
  'beotch',
  'biatch',
  'biteme',
  'bloody',
  'bodily',
  'bohunk',
  'bollok',
  'bollox',
  'booger',
  'bookie',
  'boonie',
  'bootee',
  'boozer',
  'bosomy',
  'buceta',
  'bugger',
  'byatch',
  'cabron',
  'cacker',
  'cahone',
  'cervix',
  'chinga',
  'clamps',
  'climax',
  'cocain',
  'coital',
  'coitus',
  'commie',
  'condom',
  'coochy',
  'coolie',
  'cooter',
  'crotch',
  'cyalis',
  'dahmer',
  'darkey',
  'darkie',
  'diddle',
  'dimwit',
  'dingle',
  'doggie',
  'doggin',
  'dommes',
  'doodoo',
  'doofus',
  'dookie',
  'douche',
  'dyefly',
  'dziwka',
  'escort',
  'extacy',
  'extasy',
  'faeces',
  'feltch',
  'femdom',
  'fetish',
  'ficken',
  'flamer',
  'flange',
  'flydie',
  'flydye',
  'fondle',
  'fungus',
  'gayboy',
  'geezer',
  'gigolo',
  'goatcx',
  'goatse',
  'goddam',
  'gokkun',
  'gringo',
  'guiena',
  'gummer',
  'gwailo',
  'gweilo',
  'hardon',
  'hentai',
  'hindoo',
  'hitler',
  'hodgie',
  'honger',
  'honkey',
  'honkie',
  'hooker',
  'hootch',
  'hooter',
  'horney',
  'huevon',
  'hummer',
  'humped',
  'humper',
  'humpin',
  'iblowu',
  'incest',
  'insest',
  'jewess',
  'junkie',
  'kaffer',
  'kaffir',
  'kaffre',
  'kanake',
  'kanker',
  'katsap',
  'kigger',
  'knulle',
  'kondum',
  'kootch',
  'kuffar',
  'libido',
  'licker',
  'lickme',
  'lolita',
  'mabuno',
  'maumau',
  'menage',
  'menses',
  'mierda',
  'mockey',
  'mockie',
  'moolie',
  'mormon',
  'moskal',
  'moslem',
  'mulkku',
  'murder',
  'muschi',
  'muther',
  'mzungu',
  'nambla',
  'necked',
  'niiger',
  'nimrod',
  'nlgger',
  'nlggor',
  'nookey',
  'nookie',
  'noonan',
  'nooner',
  'nudger',
  'nudity',
  'orafis',
  'orgies',
  'orospu',
  'pastie',
  'peenus',
  'peepee',
  'peinus',
  'penial',
  'penile',
  'penuus',
  'peyote',
  'phalli',
  'piefke',
  'pimmel',
  'pommie',
  'pooper',
  'punani',
  'punany',
  'pusies',
  'qahbeh',
  'queers',
  'queerz',
  'quicky',
  'qweers',
  'qweerz',
  'racial',
  'raging',
  'raunch',
  'rectal',
  'rectum',
  'rectus',
  'reefer',
  'rigger',
  'rimjaw',
  'rimjob',
  'russki',
  'schizo',
  'scroat',
  'seduce',
  'shipal',
  'skanck',
  'skribz',
  'sleaze',
  'sleazy',
  'sloper',
  'slopes',
  'slopey',
  'smoker',
  'snatch',
  'spooge',
  'steamy',
  'stiffy',
  'stoned',
  'stoner',
  'stroke',
  'stupid',
  'sultry',
  'swalow',
  'tantra',
  'terror',
  'testis',
  'throat',
  'thrust',
  'tinkle',
  'tortur',
  'tosser',
  'tranny',
  'trashy',
  'trojan',
  'turnon',
  'undies',
  'vajina',
  'valium',
  'viagra',
  'virgin',
  'voyeur',
  'vulgar',
  'vullva',
  'wedgie',
  'weenie',
  'weewee',
  'weiner',
  'weirdo',
  'wigger',
  'willie',
  'wuzzie',
  'xrated',
  'yarpie',
  'yeasty',
  'zigabo',
  'arabush',
  'aroused',
  'bagging',
  'bazooms',
  'beatoff',
  'bellend',
  'bestial',
  'bigbutt',
  'bitties',
  'blowjob',
  'bluegum',
  'boffing',
  'boiolas',
  'bollick',
  'bollock',
  'bombers',
  'bombing',
  'bondage',
  'bootlip',
  'brothel',
  'buffies',
  'bukkake',
  'buttman',
  'buttons',
  'camgirl',
  'carruth',
  'chunger',
  'chunkys',
  'coochie',
  'cracker',
  'diligaf',
  'dipship',
  'dolcett',
  'dudette',
  'enculer',
  'fanculo',
  'felatio',
  'fellate',
  'figging',
  'flasher',
  'flikker',
  'footjob',
  'funeral',
  'gangsta',
  'gaygirl',
  'gaylord',
  'gstring',
  'guineas',
  'handjob',
  'helvete',
  'honkers',
  'horndog',
  'hosejob',
  'hotcarl',
  'hugefat',
  'humpher',
  'humphim',
  'hustler',
  'illegal',
  'israels',
  'jerries',
  'jimfish',
  'khokhol',
  'kicking',
  'kimchis',
  'kinbaku',
  'licking',
  'lovegoo',
  'lovegun',
  'lowlife',
  'lubejob',
  'lucifer',
  'mahbuno',
  'mamhoon',
  'maricon',
  'mideast',
  'mrhands',
  'mulatto',
  'muncher',
  'nawashi',
  'orifice',
  'orifiss',
  'panooch',
  'pansies',
  'peeenus',
  'peehole',
  'pegging',
  'pendejo',
  'phungky',
  'pierdol',
  'playboy',
  'pollock',
  'pooping',
  'preteen',
  'punanny',
  'quashie',
  'quickie',
  'rearend',
  'recktum',
  'reestie',
  'refugee',
  'rimming',
  'sanchez',
  'scheiss',
  'schlong',
  'schmuck',
  'septics',
  'sheeney',
  'shemale',
  'shibari',
  'shinola',
  'shylock',
  'slapper',
  'slopies',
  'sooties',
  'spitter',
  'splooge',
  'spludge',
  'squinty',
  'suicide',
  'swallow',
  'swinger',
  'tainted',
  'tarbaby',
  'tastemy',
  'trannie',
  'triplex',
  'tubgirl',
  'upskirt',
  'urethra',
  'vjayjay',
  'waysted',
  'welcher',
  'wetspot',
  'whacker',
  'whigger',
  'wichser',
  'andskota',
  'babeland',
  'backdoor',
  'bareback',
  'bazongas',
  'beastial',
  'beeyotch',
  'birdlock',
  'blumpkin',
  'butthole',
  'buttmuch',
  'buttplug',
  'buttwipe',
  'cameltoe',
  'chinaman',
  'chinamen',
  'chunkies',
  'clansman',
  'clansmen',
  'cornhole',
  'creampie',
  'cyberfuc',
  'defecate',
  'dipstick',
  'dpaction',
  'earotics',
  'essohbee',
  'fellatio',
  'footstar',
  'foreskin',
  'foursome',
  'frotting',
  'futanari',
  'gonzagas',
  'goodpoop',
  'hardcore',
  'henhouse',
  'homicide',
  'horndawg',
  'horniest',
  'jailbait',
  'jijjiboo',
  'klootzak',
  'knockers',
  'lapdance',
  'lingerie',
  'lovebone',
  'manhater',
  'manpaste',
  'masokist',
  'numbnuts',
  'omorashi',
  'ontherag',
  'peepshow',
  'peepshpw',
  'playgirl',
  'ponyplay',
  'radicals',
  'rosebuds',
  'rosypalm',
  'roundeye',
  'santorum',
  'scantily',
  'schaffer',
  'schlampe',
  'sharmuta',
  'sharmute',
  'snowback',
  'stringer',
  'stroking',
  'swastika',
  'syphilis',
  'testical',
  'testicle',
  'thicklip',
  'thirdeye',
  'thirdleg',
  'threeway',
  'trombone',
  'vietcong',
  'wetdream',
  'zabourah',
  'zoophile'
].sort();

const formats = {
  all: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
  default: 'abcdefghijklmnopqrstuvwxyz',
  numbers: '0123456789'
};

const generate = (length, format = 'default') => {
  let result = '';
  const characters = formats[format];
  const vowels = ['a', 'e', 'i', 'o', 'u'];

  if (format === 'numbers') {
    while (result.length < length) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  while (result.length < length) {
    const char = characters.charAt(Math.floor(Math.random() * characters.length));
    if (!vowels.includes(char) || !vowels.includes('last')) {
      result += char;
    }
  }
  return result;
};

export const randomId = (length = 12, format) => {
  const iterate = () => {
    const result = generate(length, format);
    let match = false;
    for (let i = 0; i < blacklist.length; ++i) {
      if (result.includes(blacklist[i])) {
        match = true;
        break;
      }
    }
    if (!match) {
      return result;
    }
    return iterate();
  };
  return iterate();
};
